import React from "react";
import "../CSS/styles.css";
import n1 from '../../assets/n1.png';
import n2 from '../../assets/n2.png';
import n3 from '../../assets/n3.png';

const News = () => {
  return (
    <div className="container mt-5 inter">
      <div className="row py-lg-5">
        <h1 className="mb-0 fw-bold bc text-center">Latest News & Insights</h1>
        <p className="mb-0 text-center blc mt-3">Stay updated with our latest articles, research, and industry insights.</p>
        <div className="col-lg-4 col-12 p-3 mt-5">
          <div className="int">
            <img src={n1} alt="" className="w-100 px-0 img-fluid" />
            <div className="p-lg-3 p-1">
              <p className="gc2 mb-0 mt-lg-0 mt-3">June 15, 2023</p>
              <p className="mb-0 mt-2 bc fs-5 fw-semibold">New Cyber Security Threats in 2023</p>
              <p className="mb-0 mt-3 gc">Our analysis of emerging cyber threats and </p>
              <p className="mb-0 gc">how organizations can protect themselves.</p>
              <div className="d-flex align-items-center mt-3">
                <p className="fw-medium bc mb-0 me-2">Read More</p>
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.224 8H13.5573" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.89062 3.33325L13.5573 7.99992L8.89062 12.6666" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-12 p-3 mt-lg-5">
          <div className="int">
            <img src={n2} alt="" className="w-100 px-0 img-fluid" />
            <div className="p-lg-3 p-1">
              <p className="gc2 mb-0 mt-lg-0 mt-3">May 23, 2023</p>
              <p className="mb-0 mt-2 bc fs-5 fw-semibold">Crisis Management Best Practices</p>
              <p className="mb-0 mt-3 gc">Key strategies for effective crisis management  </p>
              <p className="mb-0 gc">in uncertain times.</p>
              <div className="d-flex align-items-center mt-3">
                <p className="fw-medium bc mb-0 me-2">Read More</p>
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.224 8H13.5573" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.89062 3.33325L13.5573 7.99992L8.89062 12.6666" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
         <div className="col-lg-4 col-12 p-3 mt-lg-5 pb-5">
          <div className="int">
            <img src={n3} alt="" className="w-100 px-0 img-fluid" />
            <div className="p-lg-3 p-1">
              <p className="gc2 mb-0 mt-lg-0 mt-3">April 10, 2023</p>
              <p className="mb-0 mt-2 bc fs-5 fw-semibold">The Future of GIS Technology</p>
              <p className="mb-0 mt-3 gc">How Geographic Information Systems are</p>
              <p className="mb-0 gc">evolving and transforming industries.</p>
              <div className="d-flex align-items-center mt-3">
                <p className="fw-medium bc mb-0 me-2">Read More</p>
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.224 8H13.5573" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.89062 3.33325L13.5573 7.99992L8.89062 12.6666" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default News